import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { router } from './router';
import { hideBootSplash } from './components/splash';
import './styles/index.css';
import { installErrorReporting } from './lib/telemetry';

declare global {
  interface Window {
    teaplus?: {
      desktop: true;
      platform: string;
      updates?: import('./lib/updates').UpdatesBridge;
      window?: import('./lib/desktop').WindowBridge;
      uninstall?: (opts?: { removeData?: boolean }) => Promise<boolean>;
      onOpen?: (cb: (route: string) => void) => () => void;
      pickFolder?: (current?: string) => Promise<string | null>;
      openFolder?: (folder: string) => Promise<boolean>;
      discord?: import('./lib/discord-presence').DiscordBridge;
    };
  }
}
if (window.teaplus?.desktop) document.documentElement.dataset.desktop = 'true';
installErrorReporting();
// Safety net: the splash never outlives a startup error.
setTimeout(hideBootSplash, 10_000);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (count, err) => {
        const status = (err as { status?: number }).status ?? 0;
        return status >= 500 || status === 0 ? count < 2 : false;
      },
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
